import { ComponentProps, FC } from 'react';
import styled from 'styled-components';

const TabsBase = styled.div`
  margin-bottom: 0;
`;
const TabButton = styled.button.attrs((p) => ({
  className: 'tab-button',
}))`
  &.tab-button {
    flex: 1 0 auto;
    margin-bottom: 0;

    @media only screen and (max-width: 768px) {
      font-size: 0.9em;
      padding: 0.5em;
    }
  }
`;

export type TabItem = {
  label: string;
  onClick?: () => void;
};

export type TabsProps = ComponentProps<typeof TabsBase> & {
  tabItems: TabItem[];
  selectedIndex?: number;
};

export const Tabs: FC<TabsProps> = ({ tabItems = [], selectedIndex = -1, ...other }) => {
  return (
    <TabsBase role="group" {...other}>
      {tabItems.map((t, index) => {
        const { label = '', onClick = () => {} } = t;

        return (
          <TabButton key={`TabButton:${index}`} disabled={index === selectedIndex} onClick={onClick}>
            {label}
          </TabButton>
        );
      })}
    </TabsBase>
  );
};
